export const EXTERNAL_URLS = {
  APPLE_STORE_APP: "https://apps.apple.com/us/app/myemblemhealth/id1588106987",
  GOOGLE_PLAY_STORE_APP:
    "https://play.google.com/store/apps/details?id=com.mysalesforce.mycommunity.C00D1I000000m19nUAA.A0OT8W000000TN1GWAW",
};
